import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

export const CHIP_BASE =
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap';

type ChipProps = {
  tone: string;
  className?: string;
  children: ReactNode;
};

export const Chip = ({ tone, className, children }: ChipProps) => (
  <span className={cn(CHIP_BASE, tone, className)}>{children}</span>
);
